import { render, staticRenderFns } from "./ReportByProductByMonthTable.vue?vue&type=template&id=ab97468a&scoped=true&"
import script from "./ReportByProductByMonthTable.vue?vue&type=script&lang=js&"
export * from "./ReportByProductByMonthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab97468a",
  null
  
)

export default component.exports